import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { Breadcrumbs, Typography } from '@tempmee/react';
import { OutlineChevronRightIcon } from '@tempmee/react-icons';

/**
 * The Best in Dental trail. Both pages carry it so the header does not jump
 * vertically when you move between them.
 *
 *   list page      **Best in Dental**
 *   a cycle        Best in Dental › **cycle name**
 *   cycle missing  Best in Dental
 *
 * The third is the 404 case: no name to show, and the link stays because it
 * is the way out. Rooted here rather than at Programs, which is a nav group
 * and not a page.
 *
 * Ancestors are react-router `Link`s, not the bare `<a>` the docs suggest:
 * Breadcrumbs styles anchor descendants via `[&_a]`, so Link inherits the
 * styling and the native-element ratchet stays flat.
 */
const CurrentCrumb = ({ children }) => (
  <Typography as="span" variant="body1" aria-current="page" className="text-text-secondary">
    {children}
  </Typography>
);

CurrentCrumb.propTypes = { children: PropTypes.node.isRequired };

export const BestInDentalBreadcrumbs = ({ cycleName, isList }) => (
  <Breadcrumbs separator={<OutlineChevronRightIcon aria-hidden className="size-4" />}>
    {isList ? (
      <CurrentCrumb>Best in Dental</CurrentCrumb>
    ) : (
      <RouterLink to="/best-in-dental">Best in Dental</RouterLink>
    )}

    {cycleName ? <CurrentCrumb>{cycleName}</CurrentCrumb> : null}
  </Breadcrumbs>
);

BestInDentalBreadcrumbs.propTypes = {
  /** The cycle's name. Omitted on the list, and when a cycle fails to load. */
  cycleName: PropTypes.string,
  /** True on the cycle list, where Best in Dental is the page you are on. */
  isList: PropTypes.bool,
};

BestInDentalBreadcrumbs.defaultProps = {
  cycleName: undefined,
  isList: false,
};

export default BestInDentalBreadcrumbs;
